import { ModuleRegistry, getRuntimeConfig } from '@eis/core';
import { insuranceModule } from '@eis/insurance';
import { partnersModule } from '@eis/partners';
import { billingModule } from '@eis/billing';
import { claimsModule } from '@eis/claims';
import { reportingModule } from '@eis/reporting';

/**
 * The module registry — the ONE file that changes when a module is added or removed
 * (backbone §2). A module PR touches its own folder plus this line; CI checks that.
 */
export const moduleRegistry = new ModuleRegistry([
  insuranceModule,
  partnersModule,
  billingModule,
  claimsModule,
  reportingModule,
]);

const selected = new Map<string, ModuleRegistry>();

/**
 * The modules THIS host serves (decision T-59, SDD-024 A-1): `config.json` `modules` selects them —
 * the Data Suite host lists `["reporting"]` — and without the key every registered module is
 * served, so the console is unchanged. Read at call time, after `loadRuntimeConfig()`, never at
 * module load (Storybook and tests inject their config after the bundle is evaluated); before a
 * config exists the whole registry answers.
 */
export function activeModuleRegistry(): ModuleRegistry {
  let ids: readonly string[] | undefined;
  try {
    ids = getRuntimeConfig().modules;
  } catch {
    return moduleRegistry;
  }
  if (ids === undefined) return moduleRegistry;
  const key = ids.join(',');
  let registry = selected.get(key);
  if (registry === undefined) {
    registry = moduleRegistry.select(ids);
    selected.set(key, registry);
  }
  return registry;
}
